import { render } from "./TomeOGT.vue?vue&type=template&id=47d90c95&scoped=true"
import script from "./TomeOGT.vue?vue&type=script&lang=js"
export * from "./TomeOGT.vue?vue&type=script&lang=js"

import "./TomeOGT.vue?vue&type=style&index=0&id=47d90c95&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d90c95"]])

export default __exports__